import StatsConfigs from "../configs/stats";
import _ from "lodash";

const StatsUtils = {
	/**
	 * Convert zone  to filters data
	 * [1, 2, null, "Label", 3] -->[{...dim1}, {...dim2}, null, "Label", {...dim3}]
	 * @param {Array} zone
	 * return {Array}
	 */
	zoneToFilters: (zone = []) => {
		const dimensions = StatsConfigs.dimensions || [];
		const filters = [];

		for (let i = 0; i < zone.length; i++) {
			const zoneItem = zone[i];
			if (zoneItem === null || typeof zoneItem === "string") {
				filters.push(zoneItem);
				continue;
			}

			const dimension = _.find(dimensions, { dimension_id: zoneItem }) || {};

			filters.push({
				...dimension,
			});
		}

		return filters;
	},
	/**
	 * Format filter to dimension type
	 * Boolean "1" --> true, "0" --> false
	 * Number "1" --> 1
	 * Any --> Any
	 * @param {object | Array} filters
	 * @return {Array} formattedFilters
	 */
	formatFilters: filters => {
		//return filters
		if (Array.isArray(filters)) {
			return StatsUtils.formatFiltersArray(filters);
		} else {
			return StatsUtils.formatFiltersItem(filters);
		}
	},
	formatFiltersArray: (filters = []) => {
		const formattedFilters = [];

		for (let i = 0; i < filters.length; i++) {
			const filter = filters[i];
			formattedFilters.push(StatsUtils.formatFiltersItem(filter));
		}

		return formattedFilters;
	},
	formatFiltersItem: ({ id = "", data = {} }) => {
		//return filters
		const dimensions = StatsConfigs.dimensions || [];
		const formattedFilters = {};
		for (const [key, values = []] of Object.entries(data)) {
			if (Array.isArray(values) && values.length > 0) {
				const dimension = _.find(dimensions, { id: key }) || {};

				if (!dimension) {
					continue;
				}

				const type = dimension.type;
				formattedFilters[key] = formattedFilters[key] || [];

				for (let i = 0; i < values.length; i++) {
					const value = values[i];

					switch (type) {
						case Boolean: {
							formattedFilters[key].push(!!(value === "1"));
							break;
						}
						case Number: {
							formattedFilters[key].push(parseInt(value));
							break;
						}
						default:
							formattedFilters[key].push(value);
					}
				}
			}
		}
		return {
			id,
			data: formattedFilters,
		};
	},
	roundKpiValue: (kpi = {}, value = 0, digits=1) => {
		const v = Math.round(value * 10000) / 10000;
		const vString = v.toFixed(digits);
		return parseFloat(vString);
	},
	addThousandsSeparator: (n, sep = " ") => {
		n = n + "";
		return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
	},
	getKpiUnit:(kpi={})=>{
		if (kpi.format === "Pourcentage" || kpi.format_input === "percentage") {
			return "%";
		}

		if (kpi.id === 16) {
			return "€";
		}

		return "";
	},
	/**
	 * Format kpi value
	 * set suffix (€, %)
	 * @param kpi
	 * @param value
	 * @param unit
	 */
	formatKpiValue: (kpi = {}, value, unit = true) => {

		if (value === null || typeof value === "string") return " - ";

		value = StatsUtils.roundKpiValue(kpi, value);

		if(kpi.calculation_type !== "somme" || kpi.format_output === "float"){
			value = value.toFixed(1);
		}

		value = value + "";
		value = StatsUtils.addThousandsSeparator(value);
		if(!unit) return value;

		if (kpi.format === "Pourcentage"|| kpi.format_input === "percentage") {
			return value + " %";
		}

		if (kpi.id === 16) {
			return value + " €";
		}

		return value;
	},
	kpiToIconClassName: (kpi = {}) => {
		return (kpi.short_label || "").toLowerCase().replace(" ", "-");
	},
};

export default StatsUtils;



// WEBPACK FOOTER //
// src/utils/stats.js